<template>
    <section>
        <div
            class="garage-about__text"
            :class="{ 'garage-about__text--expanded': expanded }"
            v-html="html"
        ></div>
        <div
            @click="expanded = !expanded"
            role="button"
            class="garage-about__toggler"
        >{{ expanded ? 'Zwiń' : 'Rozwiń' }}</div>
    </section>
</template>

<script
    setup
    lang="ts"
>
import { h } from 'vue';

const props = defineProps<{
    class: string;
    html: string;
}>();

// data
const expanded: Ref<boolean> = ref(false);
const shortDescriptionLength: number = 60;

// computed
const htmlContent = computed(() => {
    return !expanded.value && props.html.length > shortDescriptionLength
        ? props.html.substring(0, shortDescriptionLength) + '...'
        : props.html;
});


const VNode = () => h('div', { class: props.class, innerHTML: htmlContent.value });
</script>

<style lang="scss">
@import url('assets/styles/components/garage-about.scss');
</style>
